import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import moment from "moment";
import { companyID } from "../../auth";
import Swal from "sweetalert2";

const ExportAttendanceModal = ({
  show,
  handleClose,
  exportSheet,
  selectedEmployee = "",
}) => {
  const currentMonth = moment().format("YYYY-MM");
  const company_id = companyID();

  const [form, setForm] = useState({
    fromMonth: currentMonth,
    toMonth: currentMonth,
    fileType: "pdf",
  });

  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (show) {
      setForm({
        fromMonth: currentMonth,
        toMonth: currentMonth,
        fileType: "pdf",
      });
      setErrors({});
    }
  }, [show]);

  const validate = (fields = form) => {
    const newErrors = {};

    if (!fields.fromMonth) newErrors.fromMonth = "From month is required.";

    if (!fields.toMonth) newErrors.toMonth = "To month is required.";
    else if (
      moment(fields.toMonth, "YYYY-MM").isBefore(
        moment(fields.fromMonth, "YYYY-MM")
      )
    ) {
      newErrors.toMonth = "To month cannot be earlier than From month.";
    }

    if (!fields.fileType) newErrors.fileType = "Please select a file type.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const closeModal = () => {
    handleClose();
    setForm({
      fromMonth: currentMonth,
      toMonth: currentMonth,
      fileType: "pdf",
    });
  };

  const handleExport = async () => {
    if (validate()) {
      setLoader(true);
      try {
        await exportSheet({
          company_id: company_id,
          employee_id: selectedEmployee,
          from: form?.fromMonth,
          to: form?.toMonth,
          fileType: form?.fileType,
        });
        closeModal();
        Swal.fire({
          title: "Export Attendance",
          text: "Attendance sheet exported successfully",
          icon: "success",
          timer: 1500,
        });
      } catch {
        closeModal();
        Swal.fire({
          title: "Export Attendance",
          text: "Something went wrong.",
          icon: "warning",
          timer: 1500,
        });
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <Modal show={show} backdrop="static" centered size="lg">
      <Modal.Header>
        <h4 className="fw-bold">Export Attendance Sheet</h4>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate>
          <Row className="mb-4">
            <Col>
              <Form.Group controlId="formFromMonth">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="month"
                  name="fromMonth"
                  value={form.fromMonth}
                  onChange={handleChange}
                  isInvalid={!!errors.fromMonth}
                  max={currentMonth}
                />
                <Form.Control.Feedback type="invalid">
                  * {errors.fromMonth}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formToMonth">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="month"
                  name="toMonth"
                  value={form.toMonth}
                  onChange={handleChange}
                  isInvalid={!!errors.toMonth}
                  max={currentMonth}
                />
                <Form.Control.Feedback type="invalid">
                  * {errors.toMonth}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col>
              <Form.Group controlId="formFileType" className="mb-4 w-100">
                <Form.Label>File Type</Form.Label>
                <Form.Select
                  name="fileType"
                  value={form.fileType}
                  onChange={handleChange}
                  isInvalid={!!errors.fileType}
                >
                  <option value="">Select File Type</option>
                  <option value="pdf">PDF</option>
                  <option value="xlsx">Excel</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  * {errors.fileType}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleExport}
          disabled={loader ? true : false}
        >
          {loader ? "Exporting..." : "Export Data"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportAttendanceModal;
